import { useEffect, useState } from "react";

/**
 *
 * @param query A string in "css format" like "(max-width: 576px)".
 * @returns true or false wether the string matches the current media. Uses `window.matchMedia(query)`.
 * <br /><br />
 * Further information:
 * https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
 * https://medium.com/@ttennant/react-inline-styles-and-media-queries-using-a-custom-react-hook-e76fa9ec89f6
 */
export const useMediaQuery = (query: string) => {
  const mediaMatch: MediaQueryList = window.matchMedia(query);
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = (e: MediaQueryListEvent) => {
      setMatches(e.matches);
    };

    mediaMatch.addEventListener("change", handler);

    return () => {
      mediaMatch.removeEventListener("change", handler);
    };
  }, [query]);

  return matches;
};
